import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'pcc-footer',
  template: `
  <div class="fixed bottom-0 surface-200 w-full text-center pb-2">
      <span class="text-color inline-block mt-2">&copy; {{ thisYear }} {{ appCompanyName }} - All rights reserved</span>
  </div>
  `,
  styles: []
})
export class FooterComponent implements OnInit {
  appCompanyName = environment.appCompanyName;
  thisYear = new Date().getFullYear();
  constructor() { }

  ngOnInit() { }
}
